import { useEffect, useState } from "react";
import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import Preloader from "@/components/Preloader";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Work from "@/components/Work";
import CaseStudies from "@/components/CaseStudies";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { initAnalytics } from "@/lib/analytics";

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App grain relative">
      <Preloader onDone={() => setReady(true)} />
      <SmoothScroll>
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Work />
          <CaseStudies />
          <About />
          <Contact />
        </main>
        <Footer />
      </SmoothScroll>
    </div>
  );
}

export default App;
